import React from "react";
import { useInjection } from "../di/ioc-provider";
import { IDossierApiClient } from "../clients/dossierApiClient";
import { TYPES } from "../di/types";
import { Alert, Typography } from "@mui/material";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

export const InviteToDossierPage = () => {
    const _dossierClient = useInjection<IDossierApiClient>(TYPES.IDossierClient);
    const [invitationLinkSucceeded, setInvitationLinkSucceded] = React.useState(false);
    const [invitationLinkFailed, setInvitationLinkFailed] = React.useState(false);
    const history = useHistory();
     const [t] = useTranslation("common");
    const invitationAccepted = (link: string) => {

        _dossierClient.acceptDossierInvitation({ key: link }).then(() => {
            setInvitationLinkSucceded(true);
            setTimeout(() => {
                history.push("/")
            },5000);
        }).catch(() => {
            setInvitationLinkFailed(true);
        })
    }
    const [invitationLink, setInvitationLink] = React.useState<string | undefined>(undefined);
    React.useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        var magicLink = queryParameters.get("magicLink");
        setInvitationLink(magicLink);

        if (magicLink != undefined) {
            invitationAccepted(magicLink);
        }
    }, [])

    return (
        <div>
            {invitationLinkSucceeded ? <Alert severity="success">{<Typography color={"#0951a4"}> {t("general.invitationAcceptedSucceeded")}</Typography>}</Alert> : <></>}
            {invitationLinkFailed ? <Alert severity="error">{<Typography color={"#0951a4"}> {t("general.invitationAcceptedFailed")}</Typography>}</Alert> : <></>}

        </div>
    )
}